<style scoped>
	#app {
		padding: 20px;
	}
	.header {
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		
	}
	.table-box {
		margin-top: 10px;
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
	}
	
	.table-header {
		padding: 15px 20px;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.box {
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
		display: flex;
		flex-wrap: wrap;
		padding: 10px 0;
		font-size: 14px;
	}
	.form-item {
		height: 60px;
		width: 380px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.form-name {
		width: 120px;
		text-align: right;
	}
	.inp {
		width: 280px;
	}
	.el-button--primary {
		background-color: #1677FF!important;
	}
	.dot {
		color: #52C51A;
		padding: 10px;
	}
	.il {
		display: flex;
		flex-direction: row;
	}
	.t-box {
		border: solid 1px #dcdcdc;
		padding: 0 4px;
		border-radius: 4px;
	}
	.t-box1 {
		border: solid 1px #3da113;
		color: #3da113;
		padding: 0 4px;
		border-radius: 4px;
		background-color: #F7FFFE;
	}
	.t-edit {
		font-size: 14px;
		padding: 0 4px;
		margin-left: 10px;
		cursor: pointer;
	}
	.t-a {
		color: #1677FF;
		text-decoration: underline;
		cursor: pointer;
	}
	.tag-btn {
		cursor: pointer;
	}
</style>
<template>
	<div id="app">
		<el-breadcrumb class="nav" separator="/" style="margin-bottom: 13px;">
			<el-breadcrumb-item>用户管理</el-breadcrumb-item>
			<el-breadcrumb-item>用户列表</el-breadcrumb-item>
		</el-breadcrumb>
		
		<div class="box">
			<div style="margin-left: 20px; display: flex; flex-direction: row; align-items: center;">
				<div>&nbsp;&nbsp;搜索：</div>
				<el-input size="mini" placeholder="UID/账号/昵称" v-model="searchForm.keyword" style="margin-right: 10px; width:200px;"></el-input>
				<el-button size="mini" type="primary" @click="getData()">搜索</el-button>
				<el-button size="mini" type="warning" @click="reset()">重置</el-button>
			</div>
		</div>
		
		<div class="table-box">
			<el-table :data="tableData" border 
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
			    <el-table-column prop="uid" label="UID" align="center" width="100"></el-table-column>
				
				<el-table-column prop="avatar" label="头像" align="center" >
					<template slot-scope="scope">
						<img :src="scope.row.avatar" style="width: 50px; height: 50px;" />
					</template>
				</el-table-column>
				
				<el-table-column prop="phone" label="手机号" align="center" >
				</el-table-column>
				<el-table-column prop="nickname" label="昵称" align="center" >
				</el-table-column>
				<el-table-column prop="orders" label="下单数" align="center">
				</el-table-column>
				
				<el-table-column prop="expense" label="总消费" align="center" >
				</el-table-column>
			
				<el-table-column prop="add_time" label="注册时间" align="center" >
				</el-table-column>
				
				<el-table-column prop="status" label="操作" fixed="right" width="220" align="center">
					<template slot-scope="scope">
					</template>
				</el-table-column>
				
			  </el-table>
			  
			  <div  style="flex-grow: 1; display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 10px 10px 0;">
			  <el-pagination
			        @size-change="handleSizeChange"
			        @current-change="handleCurrentChange"
			        :current-page="currentPage"
			        :page-sizes="[10, 20, 50, 100]"
			        :page-size="limit"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="total">
			      </el-pagination>
			  </div>
		</div>
		<el-dialog title="推送消息  -  [ECS]快捷退出" :visible.sync="pushShow" v-if="pushShow" width="600px" :close-on-click-modal="false" :before-close="handleClose">
		  <Push :info="info"></Push>
		</el-dialog>
		
		<el-dialog title="钱包  -  [ECS]快捷退出" :visible.sync="walletShow" v-if="walletShow" width="800px" :close-on-click-modal="false" :before-close="handleClose">
		  <wallet :info="info"></wallet>
		</el-dialog>
		
		<el-dialog title="编辑  -  [ECS]快捷退出" :visible.sync="editShow" v-if="editShow" width="800px" :close-on-click-modal="false" :before-close="handleClose">
		  <editUser :oldInfo="info"></editUser>
		</el-dialog>
		
	</div> 
</template>

<script>
	import Push from './Push.vue';
	import editUser from './editUser.vue';
	import wallet from './wallet.vue'
	
	export default {
		components:{
			Push, editUser, wallet
		},
		computed:{
		},
		data(){
			return {
				sel_agent:[{label:'全部', value:''},{label:'代理', value:'2'}, {label:'会员', value:'1'}],
				sel_online:[{label:'全部', value:''},{label:'在线', value:'2'}, {label:'下线', value:'1'}],
				sel_endTime:[{label:'默认排序', value:''},{label:'到期正序', value:'1'}, {label:'到期倒序', value:'2'}],
				sel_pid:[],
				dialogVisible1:false,
				dialogVisible:false,
				loading:false,
				currentPage:1,
				tableData: [],
				total:0,
				limit:20,
				editInfo:{},
				searchForm:{
					keyword:'',
					is_agent:'',
					online:'',
					endTime:'',
					pid:'',
				},
				pushShow:false,
				walletShow:false,
				editShow:false,
				info:{},
			}
		},
		created() {
			this.getData();
		},
		methods:{
			reset(){
				this.searchForm = {
					keyword:'',
					is_agent:'',
					online:'',
					endTime:'',
					pid:'',
				};
			},
			deleteApi(scope){
				let _this = this;
				_this.loading = true;
				_this.$api.post("/User/deleteUser", {uid:scope.row.uid}).then(res=>{
					_this.loading = false;
					if(res.code == 200){
						_this.tableData.splice(scope.$index, 1);
						_this.$message({ message: '删除成功', type: 'success', });
					}else{
						_this.$message({ message: '删除失败', type: 'warning', });
					}
				}).catch(res=>{
					_this.loading = false;
				});
			},
			handleClose(){
				this.pushShow = false;
				this.walletShow = false;
				this.editShow = false;
			},
			getData(){
				let that = this;
				that.loading = true;
				that.$api.post("/User/getUserList", {page:this.currentPage, limit:this.limit, ...this.searchForm}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
					that.total = res.data.total;
				}).catch(res=>{
					that.loading = false;
				});
			},
			handleSizeChange(e){
				this.limit = e;
				this.getData();
			},
			handleCurrentChange(e){
				this.currentPage = e;
				this.getData();
			}
		}
	}
</script>

